var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarters(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.504 4.864l-2.368-2.368c-.496-.528-1.36-.528-1.872 0L7.328 4.432v8.464l6.16-6.16a1.29 1.29 0 00.016-1.872zM14.672 10h-2.336l-6 6h8.336c.736 0 1.328-.592 1.328-1.328v-3.344c0-.736-.592-1.328-1.328-1.328zM4.672 0H1.328C.592 0 0 .592 0 1.328v11.664A2.994 2.994 0 003.008 16a2.984 2.984 0 003.008-3.008V1.328A1.349 1.349 0 004.672 0zM3.008 14.336a1.325 1.325 0 01-1.328-1.328c0-.736.592-1.328 1.328-1.328.736 0 1.328.592 1.328 1.328 0 .736-.608 1.328-1.328 1.328z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarters);
export default "/_next/static/images/13a0e3db34f9034a9ec274b118afdbcd.svg";
export { ForwardRef as ReactComponent };